import xlSas from '../view/systemManage/xl-sas/xl-sas.vue'
import eventAccept from '../view/systemManage/xl-sas/event-accept/event-accept.vue'
import msgRelease from '../view/systemManage/xl-sas/msg-release/msg-release.vue'
import userDevelop from '../view/systemManage/xl-sas/user-develop/user-develop.vue'


const xlSastics = {
    path: '/xl-sas',
    component: xlSas,
    redirect: '/xl-sas/event-accept',
    children: [
        {
            path: '/xl-sas/event-accept',
            name: 'eventAccept',
            component: eventAccept,
            meta: {
                title: '事件受理'
            }
        },{
            path: '/xl-sas/user-develop',
            name: 'userDevelop',
            component: userDevelop,
            meta: {
                title: '用户发展'
            }
        },{
            path: '/xl-sas/msg-release',
            name: 'msgRelease',
            component: msgRelease,
            meta: {
                title: '信息发布'
            }
        }
    ]
}

export default xlSastics
